import jwt_decode from "jwt-decode"

export function decodeToken(token) {
  return token === null || token === "null" ? null : jwt_decode(token)
}
